import Affectation_Form from "./form";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const Affectation_Add_For_Infrastructure = () => {
    
    const { infra_key } = useParams();
    
    return ( <>
    
        <div className="pageHeader">
            <h1 className="pageTitle">Nouvelle affectation</h1>
        </div>
        <Affectation_Form forInfra infra_token={infra_key} />
    </> );
}
 
export default Affectation_Add_For_Infrastructure;